import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";

export const Promotion_website_service = {
    find_promotion,
    get_provider_list,
    remove_promotion
}


function find_promotion(filter) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "promotion_website/findPromotion/?authorization=" + json_cookie.token, filter)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function get_provider_list() {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "promotion_website/getProviderList/?authorization=" + json_cookie.token)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function remove_promotion(objinfo){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "promotion_website/removePromotion/?authorization=" + json_cookie.token, objinfo)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}